import { registerComponents } from './aurora-framework';

export const initPlugins = () => {
	registerComponents();
};
